<template>
  <div class="animated fadeIn list-of-loan">
    <b-card>
      <div slot="header">{{ $route.meta.label }}  
        <div class="card-header-actions">
          <b-dropdown text="action" variant="primary mr-1" :disabled="(selected.length==0)">
            <b-dropdown-item @click="showFormPaid=true" >Mark as Paid</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="showFormSkip=true" >Skip to Next Month</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="markUnPaid" >Mark as UnPaid</b-dropdown-item>
          </b-dropdown>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>

      <b-row >
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><label style="width: 180px;">Jt. Tempo Angsuran Bulan</label></b-input-group-prepend>
                <vue-monthly-picker v-model="model.tanggal" dateFormat="MMMM YYYY" :monthLabels="monthLabels" @selected="onChangeMonth" ></vue-monthly-picker>
                <!-- <b-form-input v-model="model.tgl2" :state="!$v.model.tgl2.$error" type="date" ></b-form-input> -->
              <b-input-group-append>
                  <b-button class="btn btn-success ml-2" @click="search()" > <i class="fa fa-play"></i> process</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" >Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="tblData.items"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
      >
      <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-loansched="data.item.loansched"
            :checked="ischeckedjurnal(data.item.loansched)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
        <template v-slot:cell(payrolldate)="data">
          {{ data.item.payrolldate | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(nilai)="data">
          {{data.item.nilai | numFormat}}
        </template>
        <template v-slot:cell(loanBalance)="data">
          {{data.item.loanBalance | numFormat}}
        </template>

      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px!important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>        
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       


    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>

    <b-modal v-model="showFormPaid"  header-bg-variant="primary" title="Payment Confirmation - Form" size="lg" :centered="true" @ok="markPaid" ok-title="Save">
          <b-form @submit.stop.prevent="save">
                <b-row>
                    <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label style="width:180px;">Tgl.Bayar Angsuran</label></b-input-group-prepend>
                        <b-form-input v-model="frmpaid.paym_date" :state="!$v.frmpaid.paym_date.$error" type="date"></b-form-input>
                    </b-input-group>
                    </b-col>
                </b-row >    
                <b-input-group>
                    <b-input-group-prepend><label style="width:180px;">Keterangan Bayar</label></b-input-group-prepend>
                    <b-form-input v-model="frmpaid.paym_remark" :state="!$v.frmpaid.paym_remark.$error"></b-form-input>
                </b-input-group>

          </b-form>
    </b-modal>
    <b-modal v-model="showFormSkip"  header-bg-variant="primary" title="SKIP Installment Confirmation - Form" size="lg" :centered="true" @ok="markSkip" ok-title="Save">
          <b-form @submit.stop.prevent="save">
                <b-input-group>
                    <b-input-group-prepend><label style="width:180px;">Keterangan</label></b-input-group-prepend>
                    <b-form-input v-model="frmskip.skip_reason" :state="!$v.frmskip.skip_reason.$error"></b-form-input>
                </b-input-group>

          </b-form>
    </b-modal>

  </div>
</template>

<style lang="scss">
    .list-of-loan {
      .input-group {
          padding-bottom:2px;
          .input-group-prepend {
              label {
                  padding-top: 5px;
                  padding-right: 5px;
                  width: 90px;
              }
          }
      }

      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
    }
 
</style>


<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
import loan from "../../apis/loan";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {   
 components: {VueMonthlyPicker,Loading},
  mixins: [validationMixin],
  validations: {
    model: {
        tanggal: { required },
        tgl1: { required },
        tgl2: { required },
    },
    frmpaid: {
      paym_date: { required },
      paym_remark: { required },
    },
    frmskip: {
      skip_reason: { required },
    },

  },
  data() {
    return {
      uanguser:this.$store.state.user.matauang,
      showFilter: false,
      showDelConfirm: false,
      showVoidConfirm: false,
      showFormPaid: false,
      showFormSkip: false,
      isLoading:false,
      showReport:false,
      isprintjv: false,
      reportUrl: null,
      model: {modeGet:'view', 
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment(this.$store.state.user.tglaktif,'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD'),
        tanggal:''},
      frmpaid: { paym_date: '',paym_remark: ''},
      frmskip: { skip_reason: ''},
      pagination: false,
      limit:20,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'crewname',
        sortDesc: true,modeGet:'view', tgl1:'', tgl2:'',
      },
  tblFields:[
        {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
        {
          key: "crewnik",
          label: "No.Karyawan",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "crewname",
          label: "Nama Karyawan",
          sortable: true
        },
        {
            key: "jabatan",
            label: "Job Title",
          },
          {
            key: "departemen",
            label: "Department",
          },
          {
            key: "locationname",
            label: "Location",
          },
          {
            key: "pinjamanNo",
            label: "No.Pinjaman",
            thStyle: "width:80px",
          },
          {
            key: "installmentNo",
            label: "Angsuran ke-",
            thStyle: "width:80px",
          },
          {
            key: "payrolldate",
            label: "Tgl. Angsuran",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "nilai",
            label: "Nilai Angsuran",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "loanBalance",
            label: "Sisa Pinjaman",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ],
      postingStatus:[{ value: '1', text: 'Posted'}, { value: '0', text: 'Not Posted'},{ value: '', text: '-- All --'}],
      filter: null,
      filterOn: ['crewnik','crewname','departemen','locationname','pinjamanNo'],   
      filterShow:'Show',   
      monthLabels:dropdown.monthLabels,
      selected:[],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmPaid() {
      this.$v.frmpaid.$touch();
      return this.$v.frmpaid.$invalid;
    },
    invalidFrmskip() {
      this.$v.frmskip.$touch();
      return this.$v.frmskip.$invalid;
    },
  },

watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    "tblData.page": function (newval) {
      this.data();
    },
    "tblData.limit": function (newval) {
      this.data();
    },
    "tblData.sortBy": function (newval) {
      this.data();
    },
    "tblData.sortDesc": function (newval) {
      this.data();
    },
    
  },  
  // created: async function() {
  //   setTimeout(() => {
  //     this.data();
  //   }, 500);
  // },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },  
    markSkip: async function(evt) {
        evt.preventDefault()
        if (this.invalidFrmSkip) {
            console.log('validation : ', this.$v.frmskip);
            console.log('model obj : ',this.frmskip);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
          try {
                const frmdata = {
                  skip_date: moment().format("YYYY-MM-DD"),
                  skip_reason: this.frmskip.paym_remark, arrKey:this.selected
                }
                await loan.markSkip(frmdata);
                toastr.success(`Update Data Success`, "SKIP Installment",10000);
                this.showFormSkip=false;
                this.data();
            } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
        }
    },
    markPaid: async function(evt) {
        evt.preventDefault()
        if (this.invalidFrmPaid) {
            console.log('validation : ', this.$v.frmpaid);
            console.log('model obj : ',this.frmpaid);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
          try {
                const frmdata = {
                  paym_date: moment(this.frmpaid.paym_date).format("YYYY-MM-DD"),
                  paym_remark: this.frmdpaid.paym_remark, arrKey:this.selected
                }
                await loan.markPaid(frmdata);
                toastr.success(`Update Data Success`, "Mark As Paid",10000);
                this.showFormPaid=false;
                this.data();
            } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
        }
    },
    markPaid2: async function (){
      console.log(`do Action for "Mark As Paid"`);
          let jawaban = false;
          jawaban = await this.$bvModal.msgBoxConfirm(` ${this.selected.length} jadwal angsuran akan di-update menjadi sudah dibayar, lanjutkan?`, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
          if (jawaban == true) {        
          }   

    },
    markUnPaid: async function (){
      console.log(`do Action for "Mark As UN Paid (Clear PAID flag)"`);
      let jawaban = false;
          jawaban = await this.$bvModal.msgBoxConfirm(` ${this.selected.length} jadwal angsuran akan di-update sebagai belum dibayar, lanjutkan?`, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
          if (jawaban == true) {        
            try {
                await loan.markUnPaid(this.selected);
                toastr.success(`Update Data Success`, "Mark As UN Paid",10000);
                this.data();
            } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
          }   
    },    
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const loansched = item.target.attributes["data-loansched"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === loansched);
        if (!(findjv)){
          this.selected.push(loansched);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === loansched);
        this.selected.splice(findIdx, 1);
      }
    },

    onChangeMonth: async function (){
      if (this.model.tanggal){
        this.model.tgl1 = moment(this.tblData.tanggal).startOf('month').format('YYYY-MM-DD');
        this.model.tgl2 = moment(this.tblData.tanggal).endOf('month').format('YYYY-MM-DD');
          // this.refresh();
      }
    },  

    data: async function(ctx) {
      if (this.invalidModel) {
        const invalidobj = {};
        for (var key in this.$v.tblData) {
          if (this.$v.tblData[key].$anyError) {
            if (this.$v.tblData[key].$anyError == true) invalidobj[key] = this.$v.tblData[key];
          }
        }
        console.log('validation field: ', invalidobj);
        console.log("tblData obj : ", this.tblData);

        toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              this.model.modeGet=='view';
              const {list,meta} = await loan.listAngsuran(this.model);
              this.pagination=true;
              this.isLoading=false;  
              this.tblData.items = list;        
              this.tblData.total = meta.total;
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
      }


    },
    refresh(ctx) {
      this.data()
    },
    search(ctx) {
      this.tblData.page=1;
      this.data()
    },
    clearFilter(ctx) {
        this.tblData.anggotaKey= '';
        this.tblData.crewnik= '';
        this.tblData.crewname=  '';
        this.tblData.jenisModal=  '';
        this.tblData.tgl2=  '';
        this.tblData.tgl2=  '';
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    print: async function()
    {
      if (this.model.trxKey) {
          try {
                this.showReport=true;
              this.reportUrl= await loan.listAngsuran(this.model);
              this.isprintjv=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
   exportxls: async function() {
      try {
          this.model.modeGet=='exportXls';
        this.tblData.modeGet='exportXls';
          const response = await loan.listAngsuran(this.model);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `daftar_trx_simpanan_modal${moment().format("YYYYMMMDD")}.xlsx`);
          document.body.appendChild(link);
          link.click();
      } catch (error) {
          this.isLoading=false;            
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }
    },
    close(){
      router.push({path:"home"});
    },    
  }
};
</script>
